import { render, staticRenderFns } from "./RomanticProductsSection.vue?vue&type=template&id=4e5d5271&"
import script from "./RomanticProductsSection.vue?vue&type=script&lang=js&"
export * from "./RomanticProductsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports